export default __webpack_public_path__ + "static/media/social-image-duplicate-for-metatags.6e2dbf44.jpg";